// root '../../../';

// dependencies
import { Child } from 'pym.js';
// import { select } from 'd3-selection';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import { stylePremium } from './utils/helpers';
// import config from './config';
// import graphic from './graphic';

// styles
import './styles/index.scss';
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';
import data from './data/data.json';

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw });

window.onload = () => {
  // necessary evil for right now

  const { pymChild } = window;
  // delay the initial resizing to give Twitter time to render tweets
  setTimeout(() => { pymChild.sendHeight(); }, 250);
  window.dispatchEvent(new Event('resize'));
};

const CNNPolitics = true;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

function draw() {
  window.dispatchEvent(new Event('resize'));
}


let showAll = false;
const INITIAL_DISPLAY_COUNT = 3;

data.forEach((item, index) => {
  item.id = index;
});

const groupedByTime = data.reduce((acc, item) => {
  acc[item.time] = acc[item.time] || [];
  acc[item.time].push(item);
  return acc;
}, {});

const nestedTimeData = Object.entries(groupedByTime).map(([time, items]) => ({
  time,
  items,
})).sort((a, b) => parseInt(a.time) - parseInt(b.time));

const container = document.getElementById('graphic');

function renderTimeline() {
  container.innerHTML = '';

  const entriesToShow = showAll ? nestedTimeData : nestedTimeData.slice(0, INITIAL_DISPLAY_COUNT);
  const hasMore = nestedTimeData.length > INITIAL_DISPLAY_COUNT;

  entriesToShow.forEach(({ time, items }) => {
    const timelineEntry = container.appendChild(document.createElement('div'));
    timelineEntry.className = 'timeline-entry';
    const date = timelineEntry.appendChild(document.createElement('h3'));
    date.className = `timeline-date ${items[0].addedClasses ? items[0].addedClasses : ''}`;
    date.innerHTML = String(time).replace('#', '');

    items.forEach((item) => {
      const content = timelineEntry.appendChild(document.createElement('div'));
      content.className = `timeline-content ${item.addedClasses ? item.addedClasses : ''}`;

      switch (item.class) {
        case 'text':
          content.innerHTML = `<p>${(item.text).replace(/\n/g, '<br>')}</p>`;
          break;
        case 'video':
          content.innerHTML = `<figure><video src="${item.src}" ${item.autoplay ? 'autoplay muted loop playsinline webkit-playsinline' : 'controls'}>
                                  <source type="video/mp4">
                              </video></figure> 
                          <figcaption> ${item.credit}  </figcaption>`;
          break;
        case 'photo':
          if (item.addedClasses && item.addedClasses.includes('inset')) {
            content.innerHTML = `<div class="inset">
                                  <figure><img src="${item.src}" /></figure>
                                  <figcaption> ${item.credit}</figcaption>
                                </div>`;
            if (item.text) {
              content.innerHTML += `<p class="inset-text">${(item.text).replace(/\n/g, '<br>')}</p>`;
            }
          } else {
            content.innerHTML = `<figure><img src="${item.src}" class="${item.addedClasses ? item.addedClasses : ''}"/></figure>
                                  <figcaption> ${item.credit}</figcaption>`;
            if (item.text) {
              content.innerHTML += `<p>${(item.text).replace(/\n/g, '<br>')}</p>`;
            }
          }
          break;
        case 'graphic':
          content.innerHTML = `<div id="responsive-embed-${item.src}" data-type="dailygraphics" data-slug="${item.src}" data-url="https://ix.cnn.io/dailygraphics/graphics/${item.src}/index.html"></div>`;

          if (!window.pym) {
            (function (b, c) { const d = document.createElement('script'); d.type = 'text/javascript', d.readyState ? d.onreadystatechange = function () { (d.readyState === 'loaded' || d.readyState === 'complete') && (d.onreadystatechange = null, c()); } : d.onload = function () { c(); }, d.src = b, document.getElementsByTagName('head')[0].appendChild(d); }('//cdn.cnn.com/cnn/.e/interactive/js/lib/vendor/pym/pym.v1.min.js', () => { new pym.Parent(`responsive-embed-${item.src}`, `//ix.cnn.io/dailygraphics/graphics/${item.src}/index.html`, { title: 'CNN Graphic' }); }));
          } else var responsiveEmbed = new pym.Parent(`responsive-embed-${item.src}`, `//ix.cnn.io/dailygraphics/graphics/${item.src}/index.html`, { title: 'CNN Graphic' });
          break;

        case 'social':
          content.innerHTML = `<p>${(item.text).replace(/\n/g, '<br>')}</p>${item.social}`;
          break;

        default:
          content.innerHTML = '<p>No content available</p>';
          break;
      }
    });
  });

  if (hasMore) {
    const showMoreContainer = container.appendChild(document.createElement('div'));
    showMoreContainer.className = 'show-more-container';
    const btn = showMoreContainer.appendChild(document.createElement('button'));
    btn.className = 'show-more-btn';
    btn.textContent = showAll ? 'Show less' : 'Show more';
    btn.addEventListener('click', () => {
      showAll = !showAll;
      renderTimeline();
      window.pymChild.sendHeight();
    });
  }
}

renderTimeline();
